window.app = window.app || {};

window.app.contentCards = {
	el: {
		section: document.querySelector('.mt-content-cards:not(.initialized)'),
		cards: null,
		cardLinks: document.querySelectorAll('.mt-card__button'),
		looties: {
			desktop: document.querySelectorAll('.mt-card__content-img .mt-lottie'),
			mobile: document.querySelectorAll('.mt-card__content-overlay .mt-lottie')
		}
	},

	init: function () {
		const _this = this;
		_this.el.cards = _this.el.section.querySelectorAll('.mt-card');

		if (!_this.el.section) return;

		_this.el.cards.forEach(card => {
			card.addEventListener('click', e => {
				if (!e.target.classList.contains('mt-btn')) {
					card.classList.toggle('active');
					_this.el.cards.forEach(c => (c !== card) && c.classList.remove('active'));
				}
			});
		});

		_this.el.cardLinks.forEach(cardLink => {
			cardLink.addEventListener('click', () => window.app.dl.contentCardClick(cardLink.dataset.page));
		});

		const cardsObserver = new IntersectionObserver( (entries, observer) => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) {
					_this.el.cards.forEach(card => {
						card.classList.remove('active');
					});
				}
			});
		}, { root: null, threshold: 0 });
		cardsObserver.observe(_this.el.section);

		// Remove unused lotties
		if (_this.el.looties.mobile.length > 0 && _this.el.looties.desktop.length > 0) {
			if (window.innerWidth >= 768) {
				_this.el.looties.mobile.forEach(lottie => lottie.remove());
			} else {
				_this.el.looties.desktop.forEach(lottie => lottie.remove());
			}
		}

		_this.el.section.classList.add('initialized');
	}
}
window.app.contentCards.init();